import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Svg } from "../Svg";
export const ClockIcon = (props) => {
    return (_jsxs(Svg, Object.assign({ viewBox: "0 0 20 20", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", defaultSize: 16 }, props, { children: [_jsx("circle", { cx: "10", cy: "10", r: "7" }), _jsx("path", { d: "M10 6v4l3 2" })] })));
};
